import React from 'react';
import SchoolPicker from './SchoolPicker';
import StoreX from '../../redux/oldStore';
import PdfViewer from '../PdfViewer/PdfViewer';
import { toast } from 'react-toastify';

interface IProps {}

const TestGround = () => {
  React.useEffect(() => {
    window.document.title = 'Test';
  }, []);

  const fileUri = StoreX.BuildUrlWithFair(`../File/ddcecd9c-b390-4c82-bc56-abba77a8cb38`);

  return (
    <>
      <h2>Testing Ground</h2>
      <hr />

      <PdfViewer
        source={fileUri}
        id={'ii'}
        allowSigning={true}
        pdfUpdated={(pdf) => {
          console.log('PDF updated, size:', pdf.size);
          //open blob in new tab
          const url = URL.createObjectURL(pdf);
          window.open(url, '_blank');
            setTimeout(() => URL.revokeObjectURL(url), 10000);

        }}
        //close={formClosed}
        //updateValues={formValuesUpdated}
        //viewOnly={true}
        //values={selectedForm.Values}
        //fieldMetaData={selectedForm.Fields}
        //signer={signer}
        //signRequested={signRequested}
        removeFile={() => {
          window.confirm('Are you sure you want to remove this file?') && toast.success('File removed successfully');
        }}
        downloadFormUrl={StoreX.BuildUrlWithFair(fileUri)}
      />
    </>
  );
};

export default TestGround;
